import $clientApi from '@/api/client'

export const checkRestaurantStatus = async (
  restaurantId: string,
  menuId: string | number
): Promise<boolean> => {
  const { data } = await $clientApi.get<{ data: boolean }>('/../menu/store/status', {
    params: { menu_id: menuId, restaurant_id: restaurantId }
  })
  return data.data
}
